import { Button, Dialog, TextField } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import {ProjectConfig} from 'Global';
import { ApiRequest } from "GlobalFunctions";

export default function VehiclesEditor(props: any) {
  const { setLoading, openEditor, setOpenEditor, vehicle_id, loadList } = props;
  const { enqueueSnackbar } = useSnackbar();

  const defaultValues = {
    vehicle_id: vehicle_id ? vehicle_id : "null",
    vehicle_name: "",
    license_plate: "",
    order_capacity: 0,
    weight_capacity: 0,
    priority: 0,
  };

  const [formValues, setFormValues] = useState(defaultValues);

  useEffect(() => {
    if (vehicle_id) {
      axios.get(`${ProjectConfig.api_url}/vehicles/details`, {
        params: { vehicle_id },
      })
      .then((response) => {
        setFormValues(response.data.data);
      })
      .catch((err) => {
        console.log(err.response);
      });
    } else {
      setFormValues(defaultValues);
    }
  }, [vehicle_id]);

  const handleInputChange = (e: { target: { name: any; value: any }; }) => {
    const { name, value } = e.target;
    const parsedValue = ["order_capacity", "weight_capacity", "priority"].includes(name) ? Number(value) : value;

    setFormValues({ ...formValues, [name]: parsedValue });
  };

  const handleSubmit = async () => {  
    setLoading(true);
    
    await ApiRequest({
      url: "/vehicles/addedit",
      method: "post",
      headers: {
        ltkn: localStorage.getItem("ltkn"),
      },
      body: {
        vehicle_id: formValues.vehicle_id,
        vehicle_name: formValues.vehicle_name,
        license_plate: formValues.license_plate,
        order_capacity: Number(formValues.order_capacity || 0),
        weight_capacity: Number(formValues.weight_capacity || 0),
        priority: Number(formValues.priority || 0)
      },
      setResponse: (response: any) => {
        if(response.status === "success"){
          enqueueSnackbar('Vehículo guardado con éxito', { variant: 'success' });
          setOpenEditor(false);
          loadList();
          
        }else{
          enqueueSnackbar(response.message, { variant: 'error' });
        }
        setLoading(false);
      },
    }); 
  };

  return (
    <Dialog open={openEditor} onClose={() => setOpenEditor(false)}>
      <div className="DialogContainer" style={{ maxWidth: '502px' }}>
        <div className="ModuleWrapper">
          <div className="boxContainerHeader">
            <div className="boxContainerTitle">
              <h2 className="h2_title">Vehículo</h2>
              <span className="h2_subtitle">Editar</span>
            </div>
          </div>

          <div className="input_group">
            <TextField
              id="vehicle_name"
              name="vehicle_name"
              label="Nombre del Vehículo"
              type="text"
              required
              fullWidth
              value={formValues.vehicle_name}
              onChange={handleInputChange}
            />

            <TextField
              id="license_plate"
              name="license_plate"
              label="Placa del Vehículo"
              type="text"
              required
              fullWidth
              value={formValues.license_plate}
              onChange={handleInputChange}
            />

            <TextField
              id="order_capacity"
              name="order_capacity"
              label="Cupo de pedidos"
              type="number"
              required
              fullWidth
              value={formValues.order_capacity}
              onChange={handleInputChange}
              inputProps={{ min: 0, step: 1 }}
            />

            <TextField
              id="weight_capacity"
              name="weight_capacity"
              label="Capacidad de peso (kg)"
              type="number"
              required
              fullWidth
              value={formValues.weight_capacity}
              onChange={handleInputChange}
              inputProps={{ min: 0, step: 0.1 }}
            />

            <TextField
              id="priority"
              name="priority"
              label="Prioridad"
              type="number"
              required
              fullWidth
              value={formValues.priority}
              onChange={handleInputChange}
              inputProps={{ min: 0, step: 1 }}
            />
          </div>

          <div className="dialogButtons">
            <Button onClick={() => setOpenEditor(false)} variant="outlined">Cancelar</Button>
            <Button onClick={handleSubmit} variant="contained">Guardar</Button>
          </div>
        </div>
      </div>
    </Dialog>
  );
}
